import React from 'react'

export const PortfolioItem = props => {
    let { side, img } = props;
    return (
        <div style={{maxWidth: '50%'}} className={`image ${side}`}>
            <img src={img} alt="design example" />
        </div>
    )
}